export const DEFAULT_LANGUAGE = "en";

export const LANGUAGE_ALIASES = {
  en: "English",
  ["fr-FR"]: "Français (French)",
};
